import {
    CLEAR_OPPORTUNITY, EMPTY_OPPORTUNITIES,
    FETCH_OPPORTUNITIES, FETCH_OPPORTUNITIES_SUCCESS, FETCH_OPPORTUNITIES_FAILURE,
    FETCH_OPPORTUNITY, FETCH_OPPORTUNITY_SUCCESS, FETCH_OPPORTUNITY_FAILURE,
    REMOVE_OPPORTUNITY, REMOVE_OPPORTUNITY_SUCCESS, REMOVE_OPPORTUNITY_FAILURE,
    SAVE_OPPORTUNITY, SAVE_OPPORTUNITY_SUCCESS, SAVE_OPPORTUNITY_FAILURE,
    SET_OPPORTUNITY, SET_OPPORTUNITIES_FILTERS, SET_OPPORTUNITIES_SEARCH_FIELD, SET_OPPORTUNITY_EMPTY_STATE,
    UPDATE_OPPORTUNITIES, SEARCH_OPPORTUNITIES, SEARCH_OPPORTUNITIES_SUCCESS,
    SEARCH_OPPORTUNITIES_FAILURE, CLEAR_SEARCH_OPPORTUNITIES
} from './constants';

import clone from 'clone';

const emptyFilters = {
    experienceIds: [],
    specializationIds: []
};

const emptyOpportunity = {
    description: null,
    endDate: null,
    experienceLevel: null,
    industryExperience: null,
    location: null,
    remote: false,
    skills: null,
    startDate: null,
    summary: null,
    title: null,
};

let emptyOpportunities = {
    drafts: [],
    published: []
};

const initialState = {
    error: {},
    isDeleting: false,
    isFetching: false,
    isSaving: false,
    opportunities: clone(emptyOpportunities),
    opportunity: clone(emptyOpportunity),
    searchResults: [],
    searchTerm: '',
    filters: clone(emptyFilters),
    shouldEmptyStore: true
};

function opportunitiesReducer(state = clone(initialState), action) {
    switch(action.type) {
        case CLEAR_OPPORTUNITY:
            return Object.assign({}, state, {
                opportunity: clone(emptyOpportunity)
            });
        case CLEAR_SEARCH_OPPORTUNITIES:
            return Object.assign({}, state, {
                searchResults: []
            });
        case EMPTY_OPPORTUNITIES:
            return clone(initialState);
        case FETCH_OPPORTUNITIES:
            return Object.assign({}, state, {
                isFetching: action.hideSpinner !== true,
                error: {}
            });
        case FETCH_OPPORTUNITIES_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                opportunities: action.data,
            });
        case FETCH_OPPORTUNITIES_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case FETCH_OPPORTUNITY:
            return Object.assign({}, state, {
                isFetching: true,
                error: {}
            });
        case FETCH_OPPORTUNITY_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                opportunity: action.data,
            });
        case FETCH_OPPORTUNITY_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case REMOVE_OPPORTUNITY:
            return Object.assign({}, state, {
                isDeleting: true,
                error: {}
            });
        case REMOVE_OPPORTUNITY_SUCCESS:
            return Object.assign({}, state, {
                isDeleting: false,
                opportunity: clone(emptyOpportunity)
            });
        case REMOVE_OPPORTUNITY_FAILURE:
            return Object.assign({}, state, {
                isDeleting: false,
                error: action.error
            });
        case SAVE_OPPORTUNITY:
            return Object.assign({}, state, {
                isSaving: true,
                error: {}
            });
        case SAVE_OPPORTUNITY_SUCCESS:
            return Object.assign({}, state, {
                isSaving: false,
                opportunity: action.data,
            });
        case SAVE_OPPORTUNITY_FAILURE:
            return Object.assign({}, state, {
                isSaving: false,
                error: action.error
            });
        case SEARCH_OPPORTUNITIES:
            return Object.assign({}, state, {
                isFetching: true,
                error: {}
            });
        case SEARCH_OPPORTUNITIES_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                searchResults: action.data
            });
        case SEARCH_OPPORTUNITIES_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case SET_OPPORTUNITY:
            return Object.assign({}, state, {
                opportunity: action.data
            });
        case SET_OPPORTUNITY_EMPTY_STATE:
            return Object.assign({}, state, {
                shouldEmptyStore: action.data
            });
        case SET_OPPORTUNITIES_SEARCH_FIELD:
            return Object.assign({}, state, {
                searchTerm: action.data
            });
        case SET_OPPORTUNITIES_FILTERS:
            return Object.assign({}, state, {
                filters: action.data
            });
        case UPDATE_OPPORTUNITIES:
            return action.data;
        default:
            return state;
    }
}

export default opportunitiesReducer;



// WEBPACK FOOTER //
// ./src/containers/Opportunities/store/reducers.js